import { toast } from 'react-toastify';
import { IErrorModel, IPaginatedResponse } from '@core/models/generic.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ProductLifeCycleService from 'services/api/productLifeCycle.service';

// -------------------------------------------------------------------------

interface IProductLifeCycleState {
    loading: boolean;
    error: IErrorModel | undefined;
    productLifeCycle: []
}

const initialState: IProductLifeCycleState = {
    loading: false,
    error: {} as IErrorModel,
    productLifeCycle: []
};

// -------------------------------------------------------------------------

export const getProductLifeCycleThunk = createAsyncThunk<
    IPaginatedResponse,
    { size: number; page: number; eventType: string; startDate: string; endDate: string },
    { rejectValue: IErrorModel }
>(`/productLifeCycle/getProductLifeCycle`, async (params, { rejectWithValue }: any) => {
    try {
        const response: any = await ProductLifeCycleService.getTraceability(params);
        return response.data.events
    } catch (err: any) {
        toast.error(err.errorMessage || 'Failed to fetch product lifecycle data', { autoClose: 5000 });
        return rejectWithValue(err);
    }
});

// -------------------------------------------------------------------------

const productLifeCycleSlice = createSlice({
    name: `productLifeCycle`,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get Product Life Cycle
        builder.addCase(getProductLifeCycleThunk.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getProductLifeCycleThunk.fulfilled, (state: any, action: any) => {
            state.loading = false;
            state.productLifeCycle = action.payload;
        });
        builder.addCase(getProductLifeCycleThunk.rejected, (state, action) => {
            state.loading = false;
            state.productLifeCycle = [];
            state.error = action.payload;
        });
    }
});

// -------------------------------------------------------------------------

export default productLifeCycleSlice;
export const productLifeCycleReducer = productLifeCycleSlice.reducer;

